export const FETCH_ALL_TODO_REQUEST = "todoReducer/FETCH_ALL_TODO_REQUEST";
export const FETCH_ALL_TODO_SUCCESS = "todoReducer/FETCH_ALL_TODO_SUCCESS";
export const FETCH_ALL_TODO_FAILED = "todoReducer/FETCH_ALL_TODO_FAILED";
export const FETCH_ALL_TODO_RESET = "todoReducer/FETCH_ALL_TODO_RESET";
